var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-10"},[_c('div',{staticClass:"text-h4 error--text"},[_vm._v("ACCESS DENIED!")]),_c('div',{staticClass:"mb-4 text-body-1"},[_vm._v("You do not have permission to view this web application.")])])
}]

export { render, staticRenderFns }